import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

interface ButtonProps {
  onClicked: () => void;
}

export const CloseButton: FC<ButtonProps> = ({ onClicked }) => (
  <button
    type="button"
    className="btn btn-lg btn-flat-secondary"
    aria-label="Close"
    data-e2e="blotter-panel-close"
    onClick={onClicked}
  >
    <i className="icon">clear</i>
  </button>
);

interface LinkButtonProps {
  labelKey: IntlKey;
  className?: string;
  url: string;
}

export const LinkButton: FC<LinkButtonProps> = ({ labelKey, className, url }) => {
  const { formatMessage } = useIntl();
  const onOpenLink = useCallback(() => {
    window.open(url, '_self');
    logAnalytics.trackEvent('Blotter Secondary Market trades', 'Open product');
  }, [url]);
  return (
    <button
      type="button"
      className={classNames(`btn btn-xl btn-discreet-primary btn-icon-start`, className)}
      onClick={onOpenLink}
    >
      <span>{formatMessage({ id: labelKey })}</span>
    </button>
  );
};
